/*
 * @Author: Du
 * @Date: 2020-04-02 09:52:04
 * @LastEditTime: 2020-04-02 09:52:44
 * @FilePath: /cn-hxapi-client/src/router/modules/sampleManagement.js
 * @Description:
 */

// 业务管理路由
import Layout from "@/layout";

const sampleRoute = [
  {
    path: "/sample-management",
    component: Layout,
    redirect: "/sample-management/sampleList",
    name: "sample-management",
    alwaysShow: true, // will always show the root menu
    meta: {
      title: "样品管理",
      icon: "check-result",
      roles: ["ROLE_STAFF"]
    },
    children: [
      {
        path: "sample-list",
        component: () => import("@/views/businessManagement/sampleList/index"),
        name: "SampleListIndex",
        meta: {
          title: "样品列表",
          icon: "check-result",
        },
      },
      {
        path: "sample-edit-list",
        component: () => import("@/views/taskCenter/sample/index"),
        name: "SampleList",
        meta: {
          title: "样品检测",
          icon: "check-result"
        }
      },
      {
        path: 'sample-processing',
        component: () => import('@/views/process/sampleProcessing/index'),
        name: 'SampleProcessing',
        meta: {
          title: '样品处理【申请】',
          icon: 'shouye'
        }
      },
      {
        path: "sample-processing-index",
        component: () => import("@/views/taskCenter/sampleProcessing/index"),
        name: "sampleProcessingIndex",
        meta: {
          title: "样品处理【审批】",
          icon: "check-result",
          noCache: true
        }
      },
      {
        path: 'editReport/:sampleNo',
        name: 'editReport',
        component: () => import('@/views/taskCenter/sample/editReport'),
        meta: {
          title: '编辑报告',
          icon: 'check-result',
        },
        hidden: true
      },
      {
        path: "view-sample-processing/:id",
        component: () => import("@/views/process/sampleProcessing/index"),
        name: "ViewSampleProcessing",
        meta: {
          title: '查看-样品处理',
          icon: 'shouye'
        },
      },
      {
        path: "approval-sample-processing/:id",
        component: () => import("@/views/process/sampleProcessing/index"),
        name: "ApprovalSampleProcessing",
        meta: {
          title: '审批-样品处理',
          icon: 'shouye'
        },
      },
    ]
  }
]
export default sampleRoute



// WEBPACK FOOTER //
// ./src/router/modules/sampleManagement.js